export const DeleteLightRed = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.238281"
      y="0.664062"
      width="45.2365"
      height="38.1576"
      rx="5.30912"
      fill="#FFEEEE"
    />
    <path
      d="M15.8574 28.7422V13.7422H14.8574V11.7422H19.8574V10.7422H25.8574V11.7422H30.8574V13.7422H29.8574V28.7422H15.8574ZM17.8574 26.7422H27.8574V13.7422H17.8574V26.7422ZM19.8574 24.7422H21.8574V15.7422H19.8574V24.7422ZM23.8574 24.7422H25.8574V15.7422H23.8574V24.7422Z"
      fill="#FF2727"
    />
  </svg>
);
